module.exports = __webpack_public_path__ + "img/rage.448e4d3d.png";